import actions from "./actions";

export default {
  actions,
  state: {
    chartAssetYear: {},
    chartAssetQuarter: {}
  },
  mutations: {
    chartAssetYear(state, payload) {
      state.chartAssetYear = payload;
    },
    chartAssetQuarter(state, payload) {
      state.chartAssetQuarter = payload;
    }
  },
  getters: {
    chartAssetYear: ({ chartAssetYear }) => chartAssetYear,
    chartAssetQuarter: ({ chartAssetQuarter }) => chartAssetQuarter
  }
};
